import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const SelectBox = ({ options, setDefault, defaultSelect, setnav }) => {
  const [showDrop, setShowDrop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentLang, setCurrentLang] = useState(localStorage.getItem("setLang") || "en");
  const { i18n } = useTranslation();

  const showDropDown = () => setShowDrop((prev) => !prev);

  const changeSelect = (lang, code) => {
    localStorage.setItem("setLang", code);
    localStorage.setItem("langName", lang);

    i18n.changeLanguage(code); // Update i18next language
    setCurrentLang(code); // Force component re-render
    setDefault(lang); // Update dropdown label
    // setShowDrop(false);
    // setnav(false);

    // Notify other components
    window.dispatchEvent(new Event("languageChanged"));
    showDropDown()
  };

  const checkMobile = () => {
    setIsMobile(window.innerWidth >= 1280);
  };

  useEffect(() => {
    // checkMobile();

    // Function to update language dynamically
    const updateLanguage = () => {
      const storedLang = localStorage.getItem("setLang");
      const storedLangName = localStorage.getItem("langName");

      i18n.changeLanguage(storedLang);
      setDefault(storedLangName);
      setCurrentLang(storedLang); // Force re-render
    };

    try {
      // checkMobile();
      updateLanguage();
      const handleStorageChange = () => updateLanguage();
      window.addEventListener("languageChanged", handleStorageChange);
      // toast.success(`Language changed to ${storedLangName ? storedLangName : "English"} successfully`);
      return () => {
        window.removeEventListener("languageChanged", handleStorageChange);
      };
    } catch (error) {
      console.error("Error in useEffect:", error);
    }
  }, [i18n.language, setDefault]); // Re-run when language changes

  return (
    <div className="dropBox">
      <div className="selectVal" onClick={showDropDown}>
        {/* {isMobile ? "Language" : defaultSelect} */}
        Language
      </div>
      <div className={`${showDrop ? "active" : ""} dropdown`}>
        {options?.map((item) => (
          <div className={`item ${currentLang === item.code ? "selected" : ""}`} key={item.code} onClick={() => changeSelect(item.lang, item.code)}>
            {item.lang} {currentLang === item.code && ""}
            {/* ✔️ */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectBox;
